import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { InputCodeEditor } from "../../../common/controls";
import { ShowBoolean } from "../../../common/controls";
import { CrudRows } from "../../../common/types";
import { ShowFilesCompact } from "../../../common/controls";
import { IMenuAction } from "../../../../common/controls";
import { FormControl } from "@mui/material";

export type BotErrorViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  errorTypeValue?: { displayId: string; id: string } | null;
  errorType: string;
  severityValue?: { displayId: string; id: string } | null;
  severity: string;
  messageValue?: { displayId: string; id: string } | null;
  message: string;
  stackTraceValue?: { displayId: string; id: string } | null;
  stackTrace: string;
  contextValue?: { displayId: string; id: string } | null;
  context: string;
  recoverableValue?: { displayId: string; id: string } | null;
  recoverable: boolean;
  requiresHumanInterventionValue?: { displayId: string; id: string } | null;
  requiresHumanIntervention: boolean;
  screenshotFiles: CrudRows;
  screenshotViewAction?: IMenuAction[];
  domSnapshotFiles: CrudRows;
  domSnapshotViewAction?: IMenuAction[];
};

export const BotErrorViewForm: React.FC<BotErrorViewFormProps> = observer(
  ({
    onPrint = () => {},
    onCancel = () => {},
    onEdit,
    showToolbox = true,
    errorType = "",
    severity = "",
    message = "",
    stackTrace = "",
    context = "{}",
    recoverable = false,
    requiresHumanIntervention = false,
    screenshotFiles,
    screenshotViewAction,
    domSnapshotFiles,
    domSnapshotViewAction,
  }) => {
    const rootStore = useRootStore();
    const { langStore } = rootStore;

    const componentRef = useRef(null);
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });

    return (
      <Grid>
        {showToolbox && (
          <FormToolbox
            editForm={onEdit}
            printForm={() => onPrint(handlePrint)}
            closeForm={() => onCancel()}
          />
        )}
        <Box ref={componentRef}>
          <GroupContainer
            id="null"
            title={langStore.groupBotErrorLabel}
            collapsible={false}
          >
            <FormControl fullWidth>
              <ShowMultiLine
                value={errorType}
                label={langStore.BotErrorErrorTypeLabel}
              />
              <ShowMultiLine
                value={severity}
                label={langStore.BotErrorSeverityLabel}
              />
              <ShowMultiLine
                value={message}
                label={langStore.BotErrorMessageLabel}
              />
              <ShowMultiLine
                value={stackTrace}
                label={langStore.BotErrorStackTraceLabel}
              />
              <InputCodeEditor
                value={context}
                onChange={() => {}}
                label={langStore.BotErrorContextLabel}
                language="json"
                readOnly={true}
              />
              <ShowBoolean
                value={recoverable}
                label={langStore.BotErrorRecoverableLabel}
              />
              <ShowBoolean
                value={requiresHumanIntervention}
                label={langStore.BotErrorRequiresHumanInterventionLabel}
              />
              <ShowFilesCompact
                rows={screenshotFiles}
                showLabel={true}
                label={langStore.BotErrorScreenshotLabel}
                menuActions={screenshotViewAction}
                columns={[
                  { name: "mimetype", title: langStore.fileTypeLabel },
                  { name: "name", title: langStore.fileNameLabel },
                  { name: "formattedSize", title: langStore.fileSizeLabel },
                ]}
              />
              <ShowFilesCompact
                rows={domSnapshotFiles}
                showLabel={true}
                label={langStore.BotErrorDomSnapshotLabel}
                menuActions={domSnapshotViewAction}
                columns={[
                  { name: "mimetype", title: langStore.fileTypeLabel },
                  { name: "name", title: langStore.fileNameLabel },
                  { name: "formattedSize", title: langStore.fileSizeLabel },
                ]}
              />
            </FormControl>
          </GroupContainer>
        </Box>
      </Grid>
    );
  }
);
